export enum FormInputType {
  TEXT = 'text',
  PASSWORD = 'password',
  EMAIL = 'email',
  NUMERIC = 'number',
  TEL = 'tel',
}
